import { render, staticRenderFns } from "./TodoDetail.vue?vue&type=template&id=c35488c0&scoped=true&"
import script from "./TodoDetail.vue?vue&type=script&lang=js&"
export * from "./TodoDetail.vue?vue&type=script&lang=js&"
import style0 from "./TodoDetail.vue?vue&type=style&index=0&id=c35488c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35488c0",
  null
  
)

component.options.__file = "TodoDetail.vue"
export default component.exports